import { Button, DatePicker, ModalPopup, Stack, Title } from 'components';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { postUpdateManagerReview } from 'store/clients/clientsActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import Avatar from '../screener/components/avatar';
import style from './managerReview.module.scss';

const ManagerReview = () => {
  const { clientId = '' } = useParams();
  const dispatch = useAppDispatch();
  const managerReview = useAppSelector((state) => state.clients.client?.data?.managerReview);
  const [open, setOpen] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      reviewDate: ''
    },
    onSubmit: async (values, helpers) => {
      await dispatch(
        postUpdateManagerReview({
          reviewDate: values.reviewDate,
          clientId
        })
      );

      helpers.resetForm();

      setOpen(false);
    }
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    formik.resetForm();
    setOpen(false);
  };

  const isEmpty = formik.values.reviewDate === '' || formik.values.reviewDate === null;

  return (
    <>
      <Button
        size="extraSmall"
        handleOnClick={handleOpen}
        text="Manager Review"
        theme="transparent"
        customStyleClass={style.managerReview}
      />
      <ModalPopup customClassInsideContainer={style.modal} open={open}>
        <Stack width="100%">
          <form onSubmit={formik.handleSubmit}>
            <Stack width="100%" display="flex" flexDirection="column" gap="16px">
              <Stack
                width="100%"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Title type="h3" text="Manager Review Date" />
                <button className={style.closeIcon} onClick={handleClose}>
                  <span className="material-icons">close</span>
                </button>
              </Stack>
              <DatePicker
                value={formik.values.reviewDate}
                onChange={(date: string) => {
                  formik.setFieldValue('reviewDate', date);
                }}
              />
              {managerReview?.lastReviewDate && (
                <Stack
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <p className={style.lastReview}>
                    Last review: {dayjs(managerReview.lastReviewDate).format('MM/DD/YYYY')}
                  </p>
                  <Stack
                    className={style.author}
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap="4px"
                  >
                    <Avatar imageUrl={managerReview.authorImage} />
                    <p>{managerReview.authorName}</p>
                  </Stack>
                </Stack>
              )}
              <Stack width="100%">
                <Button
                  disabled={isEmpty || formik.isSubmitting}
                  theme="primary"
                  text="Save"
                  type="submit"
                />
              </Stack>
            </Stack>
          </form>
        </Stack>
      </ModalPopup>
    </>
  );
};

export default ManagerReview;
